export const projects = [
  {
    title: "ChatGPT Assistant",
    subtitle: "Python",
    description: "Talk to ChatGPT with your voice using Python",
    link: "https://www.youtube.com/embed/MUCwANfFvYk",
  },
  {
    title: "Video Downloader",
    subtitle: "Python",
    description:
      "Download videos and audio from youtube with Python",
    link: "https://www.youtube.com/embed/Fo_KDYcqKGI",
  },
];

export const skills = [
  "Python",
  "Django",
  "Flask",
  "JavaScript",
  "React",
  "Next.js",
  "Node",
  "Material UI",
  "Flutter",
  "SQL / NoSQL"
];



// WEBPACK FOOTER //
// ./src/data.js